import { useCallback, useContext, useEffect } from 'react';
import { HighLeverageModeConfigSubscriberContext } from 'src/providers/HighLeverageModeConfigSubscriberProvider';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';

const DEFAULT_DATA = {
	maxUsers: 0,
	currentUsers: 0,
};

const useHighLeverageSpotsOpen = () => {
	const { highLeverageModeConfigSubscriber } = useContext(
		HighLeverageModeConfigSubscriberContext
	);
	const set = useDriftStore((s) => s.set);
	const highLeverageSpots = useDriftStore((s) => s.highLeverageSpots);

	const data =
		highLeverageModeConfigSubscriber?.getHighLeverageModeConfigAccountAndSlot()
			?.data || DEFAULT_DATA;

	// Sync the data to DriftStore whenever it changes
	useEffect(() => {
		const spotsOpen = data.maxUsers - data.currentUsers;

		// Only update if the data has actually changed
		if (
			highLeverageSpots.maxUsers !== data.maxUsers ||
			highLeverageSpots.currentUsers !== data.currentUsers ||
			highLeverageSpots.spotsOpen !== spotsOpen
		) {
			set((s) => {
				s.highLeverageSpots = {
					maxUsers: data.maxUsers,
					currentUsers: data.currentUsers,
					spotsOpen,
				};
			});
		}
	}, [data.maxUsers, data.currentUsers, highLeverageSpots, set]);

	const updateHighLeverageSlotsOpen = useCallback(() => {
		highLeverageModeConfigSubscriber?.fetch();
	}, [highLeverageModeConfigSubscriber]);

	return {
		highLeverageMaxUsers: data.maxUsers,
		highLeverageSpotsOpen: data.maxUsers - data.currentUsers,
		updateHighLeverageSlotsOpen,
	};
};

export default useHighLeverageSpotsOpen;
